import { useEffect, useState } from 'react';
import { InformationReqResponse } from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import SurveyInfoByJobComponent from '../../../../components/SurveyBuilder/SurveyInfoByJobComponent';

export interface IComponentProps {
  open: boolean;
  onClose: () => void;
  RTRData: InformationReqResponse;
}

interface SurvayResponseData {
  ques: string;
  ans: string;
}

const InformationDrawer = ({ open, onClose, RTRData }: IComponentProps) => {
  const [templateJsonObject, setTemplateJsonObject] = useState('');
  const [responseData, setResponseData] = useState<SurvayResponseData[]>();

  useEffect(() => {
    (() => {
      if (RTRData.informationReqTemplate) {
        const keys = Object.keys(RTRData.response);
        const feedbackArray = keys.map((ques) => ({
          ques,
          ans: RTRData.response[ques],
        }));
        setTemplateJsonObject(JSON.parse(JSON.stringify(RTRData.informationReqTemplate.category)));
        setResponseData(feedbackArray);
      }
    })();
  }, [RTRData]);

  return (
    <WsDrawer open={open} onClose={onClose} title="Candidate Information" size="small">
      <SurveyInfoByJobComponent
        surveyJson={templateJsonObject}
        isEditMode={false}
        responseData={responseData}
        survayResponse={true}
        showBackButton={false}
      />
    </WsDrawer>
  );
};

export default InformationDrawer;
